import React, { useState } from 'react';

function TextInput({ placeholder, onSubmit }) {
    const [text, setText] = useState("");

    return (
        <form onSubmit={event => { event.preventDefault(); onSubmit(text); setText("")}}>
            <input
                type="text"
                name="value"
                value={text}
                placeholder={placeholder}
                onChange={event => setText(event.target.value)} />
        </form>
    )
}

export default TextInput